require('./eventsService');
require('../../favorites/favoritesService');

angular.module('app.coverage.events.eventsController', [
  'app.coverage.events.eventsService',
  'app.favorites.favoritesService'
])
  .controller('app.coverage.events.eventsController', [
    '$scope',
    '$state',
    'app.coverage.events.eventsService',
    'app.favorites.favoritesService',
    function ($scope, $state, eventsService, favorites) {
      'use strict';

      $scope.eventFilter = 'upcoming';
      $scope.pager = {
        items: [],
        pageSize: 20,
        totalItems: null,
        currentPage: 1,
        currentList: 'upcoming',
        pageChanged: function () {
          let selectedEvent = eventsService.typeList[this.currentList],
            start = (this.currentPage - 1) * this.pageSize,
            end = start + this.pageSize;
          this.totalItems = selectedEvent.list.length;
          this.items = selectedEvent.list.slice(start, end);
        },
        reset: function (eventType) {
          this.currentPage = 1;
          if (eventType) {
            this.currentList = eventType;
          }
          this.pageChanged();
        }
      };

      $scope.favorites = favorites;

      $scope.filterEvents = (eventType) => {
        eventsService.getEventsByType(eventType)
          .then(() => {
            $scope.pager.reset(eventType);
          });
      };

      $scope.goToSchedule = function (event) {
        $state.go('app.schedule', {type: 'event', id: event.calid});
      };

      /**
       * @param {Event} event
       * @returns {string}
       */
      $scope.eventDate = function (event) {
        let start_date = moment(event.calstartdate);
        let end_date = moment(event.calenddate);

        return start_date.format('MMMM DD-') + end_date.format('DD, YYYY');
      };

      eventsService.getEventsByType()
        .then(() => {
          $scope.pager.reset($scope.eventFilter);
        });

      favorites.retrieve_if_empty();
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/coverage/events/eventsController.js